import React from "react";

export function TimeRangeButton(props) {
    return <div

        className={`btn btn-xs ${props.period?.id === props.setting.periodID
            ? "btn-primary"
            : ""
        }`}
        onClick={props.onClick}
    >
        {props.period.display}
    </div>;
}